import Axios from "../../../Config/API";
import {
    CadastrarTipoDocumentoInterface,
    TipoDocumentoInterface,
} from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoDocumento/TipoDocumentoInterface";
import Service from "../../../Service";

//TipoDocumento

export async function CadastratarTipoDocumentoService(
    requestBody: CadastrarTipoDocumentoInterface
) {
    return Service(
        Axios.post(`/home/tipodocumento/cadastrartipodocumento`, requestBody)
    );
}
export async function ListarTipoDocumentoService() {
    return Service(
        Axios.get<Array<TipoDocumentoInterface>>(
            `/home/tipodocumento/listartipodocumentos`
        )
    );
}

export async function ListarClassificacaoDocumentoService() {
    return Service(
        Axios.get(`/home/tipodocumento/listarclassificacaodocumento`)
    );
}

export async function EditarTipoDocumentoService(
    requestBody: TipoDocumentoInterface
) {
    return Service(
        Axios.put(`/home/tipodocumento/atualizartipodocumento`, requestBody)
    );
}

export async function DeletarTipoDocumentoService(IDTipoDocumento: number) {
    return Service(
        Axios.delete(
            `/home/tipodocumento/deletartipodocumento?IDTipoDocumento=${IDTipoDocumento}`
        )
    );
}
